import callApi from "Common/utils/apiCaller";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import ReactSelect from "../ReactSelect/ReactSelect";
import BlogType from "../../../constants/BlogType.json";
import Button from "../ButtonComponent/Button";
import descriptionSegment from "../../../constants/descriptionStyle.json";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import CustomInput from "../InputFields/CustomInput";

import BlogFeaturesCard from "../BlogFeaturesCard";

import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import { showNotification } from "Common/utils/Notification";

const BlogFeatures = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const buttonData = data?.quick_filters ? data?.quick_filters : [];
  const [buttons, setButtons] = useState(buttonData);
  const [imageUrl, setImageUrl] = useState(data?.dynamic_blogs);
  const [headerText, setHeaderText] = useState(data?.header_text);
  const [blogType, setBlogType] = useState<any>("");
  const [saticStyle, setStaticStyle] = useState<any>();
  const [styleType, setStyleType] = useState("");
  const [staticBlog, setStaticBlog] = useState<any>("");
  const [staticData, setStaticData] = useState([]);
  const [blogData, setBlogData] = useState([]);
  const [blog, setBlog] = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>(
    data?.background_image_id ? data?.background_image_id : ""
  );
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>(
    data?.mobile_background_image_id
  );
  const [indexBack, setIndexBack] = useState(undefined);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setBackgroundImage(imageData.media_url);
          setBackgroundImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  useEffect(() => {
    if (data && data?.blog_type) {
      setStaticBlog({ label: data?.blog_type, value: data?.blog_type });
      setBlogType(data?.blog_type);
      setStyleType(data?.style);
      setStaticStyle({ label: data?.style, value: data?.style });
    }
  }, [data]);

  const [errors, setErrors] = useState<any>({
    headerText: "",
    blog_type: "",
    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });

  const addButton = () => {
    setButtons([...buttons, { label: "", value: "" }]);
    setErrors({
      ...errors,
      buttons: [...errors.buttons, { label: "", value: "" }],
    });
  };
  console.log(data);

  const handleBlogData = (name, event) => {
    if (event.value === "Select...") {
      setBlogType("");
    } else {
      setBlogType(event.value);
      setStaticBlog(event);
    }
    setErrors((prev) => ({ ...prev, ["blog_type"]: "" }));
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) =>
      i === index ? { ...button, [field]: value } : button
    );
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  useEffect(() => {
    async function fetchData(params: string[]) {
      const arr: { label: string; value: string }[] = [];
      const arr1 = [];
      try {
        for (const item of params) {
          const localData = await callApi(`v1/blog/${item}`, "get", {});
          if (localData?.status === "Success") {
            arr.push({
              label: localData?.data?.blog?.heading,
              value: localData?.data?.blog?._id,
            });
            arr1.push(localData?.data?.blog?._id);
          }
        }
        setStaticData(arr);
        setBlog(arr1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    if (data?.static_blogs && data?.static_blogs?.length !== 0) {
      fetchData(data?.static_blogs);
    }
  }, [data]);

  useEffect(() => {
    fetchBlog();
  }, []);
  const fetchBlog = async () => {
    const localData = await callApi("v1/blog/list", "post", {
      pageNum: 1,
      pageSize: 1000,
      filters: { is_version_copy: false },
    });

    if (localData?.status === "Success") {
      setBlogData(
        localData.data.blogList.map((item) => {
          return {
            label: item.heading,
            value: item._id,
          };
        })
      );
    }
  };

  const handleChange = (event) => {
    let arr = [];

    for (let item of event) {
      arr.push(item.value);
    }
    setBlog(arr);
    setStaticData(event);
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      headerText: headerText.trim() === "" ? "Please enter a header." : "",
      blog_type: blogType.trim() === "" ? "Please enter Blog Type." : "",

      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "Label is required";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "Value is required";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.headerText &&
      !newErrors.blog_type &&
      newErrors?.buttons?.every((error) => !error.label && !error.value)
    ) {
      const payload = {
        segment_type: "blog_segments",
        dynamic_blogs: imageUrl,
        blog_type: blogType,
        header_text: headerText,
        static_blogs: blog,
        quick_filters: buttons,
        style: styleType,

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Blog added successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the blog. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div>
          <ToggleSwitch
            selectValue={data?.is_visible}
            versionValue={versionData?.is_visible}
            toggle={() =>
              toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
            }
            label="Is Segment Visible?"
            required={true}
          />
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="header_text"
            type="text"
            value={headerText}
            placeholder="Enter header text"
            onChange={(e) => {
              setHeaderText(e.target.value);
              setErrors((prev) => ({ ...prev, ["headerText"]: "" }));
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={errors?.headerText}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <label className="inline-block mb-2 text-base font-medium">
            Select Blog Type
          </label>
          <ReactSelect
            options={BlogType}
            isSearchable={false}
            isMulti={false}
            placeholder={"Please select blog type"}
            contentType={staticBlog}
            handleContentChange={handleBlogData}
            name={"blog_type"}
            id={"blog-type1"}
            versionData={
              versionData?.blog_type
                ? {
                  label: versionData.blog_type,
                  value: versionData.blog_type,
                }
                : null
            }
          />
          {errors.blog_type && (
            <p className="text-red-500">{errors.blog_type}</p>
          )}
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              options={descriptionSegment}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type2"}
              versionData={
                versionData?.style
                  ? {
                    label: versionData?.style,
                    value: versionData?.style,
                  }
                  : null
              }
            />
          </div>
        </div>
        {blogType === BlogType?.[1]?.value && (
          <div className="mb-4 xl:col-span-12">
            <label className="inline-block mb-2 text-base font-medium">
              Static Blogs
            </label>
            <ReactSelect
              options={blogData}
              isSearchable={true}
              isMulti={true}
              isClearable={true}
              placeholder="Static Blogs"
              contentType={staticData}
              handleContentChange={(name, event) => {
                handleChange(event || []);
              }}
              name="blog_type"
              id="choices-single-default7"
              versionData={
                versionData?.static_news
                  ? versionData.static_news.map((id: string) => ({
                    value: id,
                    label:
                      blogData.find((item) => item.value === id)?.label || id,
                  }))
                  : null
              }
            />
          </div>
        )}
        {blogType === BlogType?.[2]?.value && (
          <div className="mb-4 xl:col-span-12">
            <CustomInput
              label=" Dynamic Blog"
              name="dynamic_blogs"
              type="text"
              value={imageUrl}
              placeholder="Enter Dynamic Blogs"
              onChange={(e) => setImageUrl(e.target.value)}
              isVersioned={versionData ? true : false}
              versionedValue={versionData?.dynamic_blogs}
              error={errors?.headerText}
            />
          </div>
        )}
        {/* Add Button */}
        <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Filters
          </button>
        </div>
        {versionData && versionData?.quick_filters?.length > 0 && (
          <p>Old Data</p>
        )}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {versionData &&
            versionData?.quick_filters?.map((button, index) => (
              <div key={index} className="py-4 xl:col-span-4">
                <BlogFeaturesCard
                  index={index}
                  button={button}
                  handleInputChange={handleInputChange}
                  errors={errors}
                  removeButton={removeButton}
                  isEditable={false}
                />
              </div>
            ))}
        </div>
        {buttons && buttons?.length > 0 && <p>New Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {buttons.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <BlogFeaturesCard
                index={index}
                button={button}
                handleInputChange={handleInputChange}
                errors={errors}
                removeButton={removeButton}
                isEditable={true}
              />
            </div>
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default BlogFeatures;
